<template>
  <div>
    <div style="display:flex;justify-content:center;margin-bottom:20px;">
        <select data-cy="filtroPedidos" v-model="statuscomanda" class="select">
            <option value=2 >Pedido Solicitado</option>
            <option value=3 >Pedido em Produção</option>
            <!-- <option value=4 >Pronto Cozinha</option>
            <option value=8 >Pronto Bar</option> -->
            <option value=9 >Pronto</option>
            <option value=5 >Pedido Entregue</option>
            <option value=6 >Pedido Cancelado</option>
        </select>
    </div>

    <!-- <BotaoVoltar :url="'/Hospede/SubCategorias/'+$route.params.idpdv+'/'+$route.params.idcategoriaprodcd" /> -->
    <div v-if="ojbPedidos && ojbPedidos.listadepedidos && ojbPedidos.listadepedidos.length > 0">

        <PedidosLista  v-if="ojbPedidos" :ojbPedidos="ojbPedidos"   :corTexto="corTexto"    />

    </div>

    <div v-else style="display:flex;min-height:70vh;justify-content:center;align-items:center;">
        <span style="font-size:20px;text-align:center">{{this.carregando ? this.carregando : $t('naopossuipedidosstatus.texto')}}</span>
    </div>

   
<!-- 
    <ModalConfirmacao :showModal="exibirModalLocal" :titulo="'Onde você está?'"
        textosim="Quarto" textonao="Restaurante" @sim="()=>setarLocal('QUARTO')" @nao="()=>setarLocal('RESTAURANTE')"  />

    <ModalConfirmacaoInput :showModal="exibirModalNumeroLocal" :titulo="`Qual o numero ${ tipoLocal == 1? ' do seu quarto?':' da sua mesa?' }`"
        textosim="Confirmar" textonao="Cancelar" @sim="(numero)=>setarNumeroLocal(numero)" @nao="()=>fecharModais()"
        :valorinicial="valorinicialmodal"  />

    <ModalConfirmacaoInput :showModal="exibirModalCartaoConsumo" :titulo="`Qual o numero do seu Cartao de Consumo?`" 
        textosim="Confirmar" textonao="Cancelar" @sim="(numero)=>setarNumeroCartaoConsumo(numero)" @nao="()=>fecharModais()"  
             />

    <ModalConfirmacao :showModal="exibirModalConfirmacao" :titulo="'Ao enviar o pedido ele não poderá ser cancelado!'"
        textosim="Enviar" textonao="Cancelar" @sim="()=>confirmarPedido()" @nao="()=>fecharModais()" />
                 -->

  </div>
</template>

<script>
  import PedidosLista from '../../components/pedidos/PedidosLista.vue'
//   import ModalConfirmacao from '../../components/layout/ModalConfirmacao.vue'
//   import ModalConfirmacaoInput from '../../components/layout/ModalConfirmacaoInput.vue'



  export default {
    name: 'Pedidos',
    components: {
      PedidosLista,
    //   ModalConfirmacao,
    //   ModalConfirmacaoInput,
    },
    watch:{
        async statuscomanda(valor){
           
            this.ojbPedidos = null
            let idreservasfront = localStorage.getItem('idreservasfront')
            this.carregando = "Carregando itens"
            this.corTexto = this.listaCores[valor].cor
            let idstatus = valor 
            if(valor == 5){
                idstatus = '5,7'
            }
            if(valor == 3){
                idstatus = '3,10,11'
            }
            if(valor == 9){
                idstatus = '4,8,9'
            }
            this.ojbPedidos = await this.getComandasReservaPorStatus(idreservasfront,idstatus)
            this.carregando = null
        },
    },
    data: () => ({
        listadepedidos:[],
        ojbPedidos:null,
        statuscomanda:2,
        listaCores:[
            {cor:"#55ad94"},
            {cor:"#55ad94"},
            {cor:"#55ad94"},
            {cor:"#555cdd"},
            {cor:"#d98e00"},
            {cor:"green"},
            {cor:"red"},
            {cor:"#d98e00"},
            {cor:"#d98e00"},
            {cor:"#d98e00"},
        ],
        corTexto:'',
        carregando:null,

    }),
    methods:{
        // async confirmarPedido(){
        //     this.$http.post(`pdv/alterarStatusPedidoEProdutos/${this.idcomanda}/2`).then(()=>{
        //         this.fecharModais()
        //         this.getComandasReservaPorStatus()
        //         this.$alertar("success","Pedido Enviado para Produção","=)")
        //     })
        //     .catch((error)=>{
        //         console.log(error)
        //         this.$alertar("success","Não foi possivel exibir os produtos no carrinho","=(")
        //     })
        //     // await this.getComandasReservaPorStatus()
        //     // this.$router.push('/Hospede/Pedidos')
        // },
        // setarNumeroLocal(numero){
        //     this.numeroLocal = numero
        //     this.exibirModalLocal = false
        //     this.exibirModalNumeroLocal = false
        //     this.exibirModalCartaoConsumo = false
        //     this.exibirModalConfirmacao = false
        //     this.exibirModalCartaoConsumo = true
        // },
        // setarNumeroCartaoConsumo(numero){
        //     this.numeroCartaoConsumo = numero
        //     this.exibirModalLocal = false
        //     this.exibirModalNumeroLocal = false
        //     this.exibirModalCartaoConsumo = false
        //     this.exibirModalCartaoConsumo = false
        //     this.exibirModalConfirmacao = true
        // },
        // setarLocal(local){
        //     if(local === 'QUARTO'){
        //         this.tipoLocal = 1
        //         this.exibirModalLocal = false
        //         this.exibirModalNumeroLocal = true
        //         this.valorinicialmodal = this.numeroLocal
        //     }
        //     if(local === 'RESTAURANTE'){
        //         this.tipoLocal = 2
        //         this.exibirModalLocal = false
        //         this.exibirModalNumeroLocal = true
        //         this.valorinicialmodal = this.numeroCartaoConsumo
        //     }
            
        // },
        // fecharModais(){
        //     this.exibirModalLocal = false
        //     this.exibirModalNumeroLocal = false
        //     this.exibirModalCartaoConsumo = false
        //     this.exibirModalCartaoConsumo = false
        //     this.exibirModalConfirmacao = false
        // },
        async getPedidosPorStatus(){
            let idreservasfront = localStorage.getItem('idreservasfront')
            this.ojbPedidos = await this.getComandasReservaPorStatus(idreservasfront,this.statuscomanda)
            this.corTexto = this.listaCores[this.statuscomanda].cor
        },
        async getComandasReservaPorStatus(idreservasfront,idstatus){
            let objetoRetorno = {}
            await this.$http('pdv/getComandasReservaPorStatus/'+idreservasfront+'/'+idstatus+'/t').then((resp) =>{
              console.log(resp.data)
              objetoRetorno.valorTotal = 0
              objetoRetorno.listadepedidos = resp.data
              console.log("objetoRetorno.listadepedidos")
              console.log(objetoRetorno.listadepedidos)
              for(var i = 0, len = objetoRetorno.listadepedidos.length; i < len; i++){
                  objetoRetorno.valorTotal += parseFloat(objetoRetorno.listadepedidos[i].valor)
                  objetoRetorno.statuscomanda = objetoRetorno.listadepedidos[i].statuscomanda
              }
              console.log("objetoRetorno")
              console.log(objetoRetorno)

            }).catch(error =>{
              console.log(error)
              this.$alertar("warning","Não foi possivel exibir os pedidos","=(")
            })

            return objetoRetorno
        },
        // retirarProdutoCarrinho(produto){
            
        //     let objetoproduto = {
        //         idprodutocomanda:produto.id,
        //         numpedido:produto.idcomanda
        //     }
        //     this.$http.post('pdv/removerProdutoNaComanda',objetoproduto).then(() =>{
        //       this.getComandasReservaPorStatus()
        //     }).catch(error =>{
        //       console.log(error)
        //       this.$alertar("warning","Não foi possivel remover o produto do carrinho","=(")
        //     })
        // },
        // direcionar(){
        //     this.$router.push('/Hospede/Menu')
        // },
        // finalizarPedido(){
        //     this.exibirModalLocal = true
        // }
    },
    mounted(){
        this.$store.dispatch("set_titulo", this.$t('titulocardapio.texto'))
        // this.getComandasReservaPorStatus()
        this.getPedidosPorStatus()
    }
  }
</script>

<style scoped>
    .select{
      
        -webkit-appearance: none; /* Remove estilo padrão do Chrome */   
        -moz-appearance: none;/* Remove estilo padrão do FireFox */  
        appearance: none; /* Remove estilo padrão do FireFox*/   
          
        background: url(http://www.webcis.com.br/images/imagens-noticias/select/ico-seta-appearance.gif) no-repeat #fff;/* Imagem de fundo (Seta) */   
        background-position: 98% center;  /*Posição da imagem do background*/  
       

        border:1px solid black;
        width: 100%;
        max-width:1000px;
        height: 50px;
        padding:10px;
        border-radius: 10px;
  
    }
</style>